import { render, staticRenderFns } from "./app_global_snackbar.vue?vue&type=template&id=33b8087c&scoped=true&"
import script from "./app_global_snackbar.vue?vue&type=script&lang=ts&"
export * from "./app_global_snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./app_global_snackbar.vue?vue&type=style&index=0&id=33b8087c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b8087c",
  null
  
)

export default component.exports